export const getDynamicHelperText = (placeholder) => {
  if (!placeholder) return 'This field is required';
  return `${placeholder} is required`;
};
